import React from "react";

const AddTransactionModal = ({
  isOpen,
  onClose,
  newTransaction,
  handleInputChange,
  handleAddTransaction,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="modal-content bg-white p-4 rounded shadow"
        style={{ width: "90%", maxWidth: "400px" }}
      >
        <h5 className="mb-3">Add Transaction</h5>
        <select
          name="type"
          value={newTransaction.type}
          onChange={handleInputChange}
          className="form-control mb-2"
        >
          <option value="expense">Expense</option>
          <option value="income">Income</option>
        </select>
        <input
          type="text"
          name="category"
          value={newTransaction.category}
          onChange={handleInputChange}
          placeholder="Category"
          className="form-control mb-2"
          required
        />
        <input
          type="number"
          name="amount"
          value={newTransaction.amount}
          onChange={handleInputChange}
          placeholder="Amount"
          className="form-control mb-2"
          step="0.01"
          min="0"
          required
        />
        <textarea
          name="description"
          value={newTransaction.description}
          onChange={handleInputChange}
          placeholder="Description (Optional)"
          className="form-control mb-2"
        ></textarea>
        <div className="d-flex justify-content-between">
          <button
            onClick={handleAddTransaction}
            className="btn btn-primary flex-grow-1 me-2"
          >
            Add Transaction
          </button>
          <button onClick={onClose} className="btn btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTransactionModal;